import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import TabSelector from "../../../Components/TabSelector";
import EpisodeList from "./Episode/EpisodeList";
import StudentList from "./Student/StudentList";
import EpisodeStats from "./EpisodeStats/EpisodeStats";
import StudentProfile from "./Student/StudentProfile";

const tabList = [
  "EPISODES",
  "DASHBOARD",
  // 'STUDENT LIST',
  "CARE ASSESSMENT",
];

class SmartClinic extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 0,
      studentId: null,
      studentProfileActive: false,
      organizationId: this.props.organizationId,

      defaultLimit: 5,
      defaultOffset: 0,
      defaultSortField: "modified_time",
      defaultSortBy: "desc",

      episodesList: [],
      episodesTotal: 0,
      episodesHeader: {},

      studentList: [],
      studentTotal: 0,
      studentHeader: {},
    };
  }

  componentWillMount() {
    let { episodeHeader, studentHeader } = this.props;
    let { organizationId } = this.state;

    this.props.fetchEpisodeSearch(
      this.buildHeader({ inOrganizationId: organizationId }, episodeHeader),
    );
    this.props.fetchNurseMeta();
    //this.props.fetchStudentSearch(this.buildHeader({inOrganizationId: organizationId}, studentHeader))
    //this.props.fetchEpisodeStats(organizationId)
  }

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {}

  buildHeader = (newHeader, oldHeader) =>
    Object.assign({}, oldHeader, newHeader);

  _renderNoDataAvail = (msg) => {
    return (
      <div className="hsg-msp-detail-empty">
        {msg ? msg : "No Data Available"}
      </div>
    );
  };

  openStudentProfile = (studentId) => {
    // studentId
    // ? this.props.resetEpisodeSearch(this.buildHeader(
    //     {
    //         "inLimit": this.state.defaultLimit,
    //         "inOffset": this.state.defaultOffset,
    //         "inSortField": this.state.defaultSortField,
    //         "inSortBy": this.state.defaultSortBy,
    //         "inStudentId": null,
    //         "inOrganizationId": null,
    //     },
    //     this.props.episodeHeader
    // ))
    // : this.props.fetchEpisodeSearch(this.buildHeader(
    //     {
    //         "inLimit": this.state.defaultLimit,
    //         "inOffset": this.state.defaultOffset,
    //         "inSortField": this.state.defaultSortField,
    //         "inSortBy": this.state.defaultSortBy,
    //         "inStudentId": null,
    //         "inOrganizationId": this.state.organizationId,
    //     },
    //     this.props.episodeHeader
    // ))

    this.setState({
      studentProfileActive: studentId ? true : false,
      studentId: studentId,
    });
  };

  _renderCurrentScreen = (state, props) =>
    state.studentProfileActive ? (
      this._renderStudentProfile(state, props)
    ) : state.selectedTab === 0 ? (
      <EpisodeList
        episodeList={props.episodeList}
        episodeTotal={props.episodeTotal}
        episodeHeader={props.episodeHeader}
        buildEpisodeHeader={(newHeader, oldHeader) =>
          this.buildHeader(newHeader, oldHeader)
        }
        fetchEpisodeSearch={(header) => this.props.fetchEpisodeSearch(header)}
        openStudentProfile={(studentId) => this.openStudentProfile(studentId)}
        noDataAvailable={(msg) => this._renderNoDataAvail(msg)}
        organizationId={props.organizationId}
        basicInfo={true}
        parentInfo={true}
        episodeInfo={true}
        headingLeft={"Name"}
        headingRight={"ModifiedTime"}
        enableEpisodeIdInBody={true}
        enableEpisodeIdLabelBody={true}
        baseClass={"container"}
        enableSearch={true}
        enableSort={true}
      />
    ) : state.selectedTab === 1 ? (
      <EpisodeStats
        stats={props.episodeStats}
        organizationId={this.props.organizationId}
        fetchEpisodeStats={(organizationId) =>
          this.props.fetchEpisodeStats(organizationId)
        }
        noDataAvailable={(msg) => this._renderNoDataAvail(msg)}
      />
    ) : state.selectedTab === 2 ? (
      <StudentList
        studentList={props.studentList}
        studentTotal={props.studentTotal}
        studentHeader={props.studentHeader}
        organizationId={this.props.organizationId}
        buildStudentHeader={(newHeader, oldHeader) =>
          this.buildHeader(newHeader, oldHeader)
        }
        fetchStudentSearch={(header) => this.props.fetchStudentSearch(header)}
        openStudentProfile={(studentId) => this.openStudentProfile(studentId)}
        noDataAvailable={(msg) => this._renderNoDataAvail(msg)}
      />
    ) : null;

  onTabSelected(pos) {
    this.setState({
      selectedTab: pos,
      studentId: null,
      studentProfileActive: false,
    });
  }

  _renderClinicTabs = (state, props) => (
    <div>
      <section className="hsg-medh-root">
        <TabSelector
          tabList={tabList}
          selected={state.selectedTab}
          onTabSelected={(pos) => this.onTabSelected(pos)}
        />
      </section>

      {this._renderCurrentScreen(state, props)}
    </div>
  );

  getStudentProfile = (episodeList, studentList, studentId) => {
    let currentStudent;
    currentStudent = episodeList.filter(
      (student, index) => student.student_id === studentId,
    );

    currentStudent =
      currentStudent && currentStudent.length ? currentStudent[0] : null;

    if (currentStudent) {
      return currentStudent;
    }

    currentStudent = studentList.filter(
      (student, index) => student.student_id === studentId,
    );

    currentStudent =
      currentStudent && currentStudent.length ? currentStudent[0] : null;

    if (currentStudent) {
      return currentStudent;
    } else {
      [];
    }
  };

  _renderStudentProfile = (state, props) => (
    <section className="hsg-medh-root">
      <StudentProfile
        episodeList={props.episodeList}
        episodeTotal={props.episodeTotal}
        episodeHeader={props.episodeHeader}
        studentId={state.studentId}
        organizationId={state.organizationId}
        basicInfo={false}
        parentInfo={false}
        episodeInfo={true}
        headingLeft={"ModifiedTime"}
        headingRight={"EpisodeId"}
        enableEpisodeIdInBody={false}
        enableEpisodeIdLabelBody={false}
        buildHeader={(newHeader, oldHeader) =>
          this.buildHeader(newHeader, oldHeader)
        }
        fetchEpisodeSearch={(header) => this.props.fetchEpisodeSearch(header)}
        closeStudentProfile={() => this.openStudentProfile(null)}
        studentProfile={this.getStudentProfile(
          props.episodeList || [],
          props.studentList || [],
          state.studentId,
        )}
        noDataAvailable={(msg) => this._renderNoDataAvail(msg)}
        postStudentEpisode={(studentId, customJson, episodeType) =>
          this.props.postStudentEpisode(studentId, customJson, episodeType)
        }
        initializeForm={(data) => this.props.initializeForm(data)}
        fetchNurseMeta={() => this.props.fetchNurseMeta()}
        metaData={{
          metaMeds: props.metaMeds,
          metaSymp: props.metaSymp,
          metaTreat: props.metaTreat,
          metaVitals: props.metaVitals,
        }}
        clearForm={() => this.props.clearForm}
      />
    </section>
  );

  render() {
    let { state, props } = this;

    return this._renderClinicTabs(state, props);
  }
}

export default SmartClinic;

// import React, { useState, useEffect } from 'react';
// import { Switch, Route, Redirect } from 'react-router-dom';
// import TabSelector from '../../../Components/TabSelector';
// import EpisodeList from './Episode/EpisodeList';
// import StudentList from './Student/StudentList';
// import EpisodeStats from './EpisodeStats/EpisodeStats';
// import StudentProfile from '../../StudentProfileContainer/Component/StudentProfile';
// import Student from '../../StudentProfileContainer/Component/StudentProfile';
// import Leftbar from '../../DashboardContainer/Component/Leftbar';
// import SchoolOverViewComponent from '../../DashboardContainer/Component/SchoolOverViewComponent';

// const tabList = ['EPISODES', 'DASHBOARD', 'STUDENT LIST'];

// const SmartClinic = (props) => {
//     const [selectedTab, setSelectedTab] = useState(0);
//     const [studentId, setStudentId] = useState(null);
//     const [studentProfileActive, setStudentProfileActive] = useState(false);
//     const [organizationId, setOrganizationId] = useState(props.organizationId);

//     const [defaultLimit, setDefaultLimit] = useState(5);
//     const [defaultOffset, setDefaultOffset] = useState(0);
//     const [defaultSortField, setDefaultSortField] = useState('modified_time');
//     const [defaultSortBy, setDefaultSortBy] = useState('desc');

//     useEffect(() => {
//         const { episodeHeader, studentHeader } = props;

//         props.fetchEpisodeSearch(buildHeader({ inOrganizationId: organizationId }, episodeHeader));
//         props.fetchNurseMeta();
//         // props.fetchStudentSearch(buildHeader({ inOrganizationId: organizationId }, studentHeader));
//         // props.fetchEpisodeStats(organizationId);
//     }, []);

//     const buildHeader = (newHeader, oldHeader) => Object.assign({}, oldHeader, newHeader);

//     const _renderNoDataAvail = (msg) => (
//         <div className="hsg-msp-detail-empty">
//             {msg ? msg : "No Data Available"}
//         </div>
//     );

//     const openStudentProfile = (studentId) => {
//         setStudentProfileActive(!!studentId);
//         setStudentId(studentId);
//     };

//     <Student
//     buildEpisodeHeader={(newHeader, oldHeader) => buildHeader(newHeader, oldHeader)}
//     fetchEpisodeSearch={(header) => props.fetchEpisodeSearch(header)}
//     openStudentProfile={(studentId) => openStudentProfile(studentId)}

//     />

//     const _renderCurrentScreen = () => {
//         const { episodeList, episodeTotal, episodeHeader, organizationId, episodeStats } = props;

//         return studentProfileActive ? _renderStudentProfile() : (
//             selectedTab === 0 ? (
//                 <EpisodeList
//                     episodeList={episodeList}
//                     episodeTotal={episodeTotal}
//                     episodeHeader={episodeHeader}
//                     buildEpisodeHeader={(newHeader, oldHeader) => buildHeader(newHeader, oldHeader)}
//                     fetchEpisodeSearch={(header) => props.fetchEpisodeSearch(header)}
//                     openStudentProfile={(studentId) => openStudentProfile(studentId)}
//                     noDataAvailable={(msg) => _renderNoDataAvail(msg)}
//                     organizationId={organizationId}
//                     basicInfo
//                     parentInfo
//                     episodeInfo
//                     headingLeft={'Name'}
//                     headingRight={'ModifiedTime'}
//                     enableEpisodeIdInBody
//                     enableEpisodeIdLabelBody
//                     baseClass={'container'}
//                     enableSearch
//                     enableSort
//                 />
//             ) : selectedTab === 1 ? (
//                 <EpisodeStats
//                     stats={episodeStats}
//                     organizationId={props.organizationId}
//                     fetchEpisodeStats={(organizationId) => props.fetchEpisodeStats(organizationId)}
//                     noDataAvailable={(msg) => _renderNoDataAvail(msg)}
//                 />
//             ) : selectedTab === 2 ? (
//                 <StudentList
//                     studentList={props.studentList}
//                     studentTotal={props.studentTotal}
//                     studentHeader={props.studentHeader}
//                     organizationId={props.organizationId}
//                     buildStudentHeader={(newHeader, oldHeader) => buildHeader(newHeader, oldHeader)}
//                     fetchStudentSearch={(header) => props.fetchStudentSearch(header)}
//                     openStudentProfile={(studentId) => openStudentProfile(studentId)}
//                     noDataAvailable={(msg) => _renderNoDataAvail(msg)}
//                 />
//             ) : null
//         );
//     };

//     const _renderClinicTabs = () => (
//         <div>
//             <section className="hsg-medh-root">
//                 <TabSelector
//                     tabList={tabList}
//                     selected={selectedTab}
//                     onTabSelected={(pos) => setSelectedTab(pos)} />
//             </section>
//             {_renderCurrentScreen()}
//         </div>
//     );

//     const getStudentProfile = (episodeList, studentList, studentId) => {
//         let currentStudent = episodeList.filter((student) => student.student_id === studentId);
//         currentStudent = currentStudent && currentStudent.length ? currentStudent[0] : null;

//         if (currentStudent) {
//             return currentStudent;
//         }

//         currentStudent = studentList.filter((student) => student.student_id === studentId);
//         currentStudent = currentStudent && currentStudent.length ? currentStudent[0] : null;

//         if (currentStudent) {
//             return currentStudent;
//         } else {
//             return [];
//         }
//     };

//     const _renderStudentProfile = () => (
//         <section className="hsg-medh-root">
//             <Student
//                 episodeList={props.episodeList}
//                 episodeTotal={props.episodeTotal}
//                 episodeHeader={props.episodeHeader}
//                 studentId={studentId}
//                 organizationId={organizationId}
//                 basicInfo={false}
//                 parentInfo={false}
//                 episodeInfo
//                 headingLeft={'ModifiedTime'}
//                 headingRight={'EpisodeId'}
//                 enableEpisodeIdInBody={false}
//                 enableEpisodeIdLabelBody={false}
//                 buildHeader={(newHeader, oldHeader) => buildHeader(newHeader, oldHeader)}
//                 fetchEpisodeSearch={(header) => props.fetchEpisodeSearch(header)}
//                 closeStudentProfile={() => openStudentProfile(null)}
//                 studentProfile={getStudentProfile(props.episodeList || [], props.studentList || [], studentId)}
//                 noDataAvailable={(msg) => _renderNoDataAvail(msg)}
//                 postStudentEpisode={(studentId, customJson, episodeType) => props.postStudentEpisode(studentId, customJson, episodeType)}
//                 initializeForm={(data) => props.initializeForm(data)}
//                 fetchNurseMeta={() => props.fetchNurseMeta()}
//                 metaData={{ metaMeds: props.metaMeds, metaSymp: props.metaSymp, metaTreat: props.metaTreat, metaVitals: props.metaVitals }}
//                 clearForm={() => props.clearForm}
//             />
//         </section>
//     );

//     return _renderClinicTabs();
// };

// export default SmartClinic;
